import { Component, inject } from '@angular/core';
import { UpperCasePipe } from '@angular/common';
import {
    DxButtonComponent,
    DxDataGridComponent,
    DxFormComponent,
    DxTemplateDirective,
} from 'devextreme-angular';
import {
    DxiColumnComponent,
    DxiItemComponent,
    DxoColumnChooserComponent,
    DxoExportComponent,
    DxoFilterRowComponent,
    DxoHeaderFilterComponent,
    DxoLoadPanelComponent,
    DxoPagerComponent,
    DxoPagingComponent,
    DxoPositionComponent,
    DxoScrollingComponent,
    DxoSearchComponent,
    DxoSearchPanelComponent,
    DxoSelectionComponent,
    DxoSortingComponent,
    DxoToolbarComponent,
} from 'devextreme-angular/ui/nested';
import { FilterPanelComponent } from '../../../components/library/filter-panel/filter-panel.component';
import {
    FilterConfig,
    GridPageComponent,
} from '../../common/grid-page.component';
import {
    AccessType,
    AuthService,
    CurrencyCode,
    InvoicePurchaseOrderGridViewDto,
    InvoicePurchaseOrderStatus,
    PermissionType,
} from '@services';
import EnumUtils from '../../../shared/enum-utils';
import { CommonModule, NgClass } from '@angular/common';
import { DxDataGridTypes } from 'devextreme-angular/ui/data-grid';
import { Router, RouterLink } from '@angular/router';
import { DATE_FORMAT } from 'src/app/shared/constants';
import { CapitalCasePipe } from 'src/app/pipes/capital-case.pipe';

@Component({
    selector: 'app-invoice-purchase-orders',
    imports: [
        CommonModule,
        CapitalCasePipe,
        DxDataGridComponent,
        DxoScrollingComponent,
        DxoPagingComponent,
        DxoPagerComponent,
        DxoLoadPanelComponent,
        DxoPositionComponent,
        DxoSortingComponent,
        DxoSearchComponent,
        DxoHeaderFilterComponent,
        DxoFilterRowComponent,
        DxoColumnChooserComponent,
        DxoSearchPanelComponent,
        DxoSelectionComponent,
        DxoExportComponent,
        DxoToolbarComponent,
        DxiItemComponent,
        DxButtonComponent,
        DxiColumnComponent,
        DxTemplateDirective,
        NgClass,
        FilterPanelComponent,
        DxFormComponent,
        RouterLink,
    ],
    providers: [UpperCasePipe],
    templateUrl: './invoice-purchase-orders.component.html',
})
export class InvoicePurchaseOrdersComponent extends GridPageComponent<InvoicePurchaseOrderGridViewDto> {
    private router = inject(Router);
    private authService = inject(AuthService);
    private upperCasePipe = inject(UpperCasePipe);

    protected override exportName: string = 'PO Report';
    protected offset: number = 100;
    public dateFormat = DATE_FORMAT;

    dataSource = this.dataSources.invoicePurchaseOrders();

    statusOptions = EnumUtils.getEnumOptions(InvoicePurchaseOrderStatus);
    currencyOptions = EnumUtils.getEnumOptions(CurrencyCode, (v) =>
        this.upperCasePipe.transform(v),
    );

    protected override filterConfig: FilterConfig[] = [
        { field: 'number', op: 'contains' },
        { field: 'serviceType', op: 'contains' },
        { field: 'vendor', op: 'contains' },
        { field: 'currency', op: '=' },
        { field: 'issueDate', op: '>=' },
        { field: 'dueDate', op: '>=' },
        { field: 'subTotal', op: '>=' },
        { field: 'taxAmount', op: '>=' },
        { field: 'totalAmount', op: '>=' },
        { field: 'convertedSubTotal', op: '>=' },
        { field: 'convertedTaxAmount', op: '>=' },
        { field: 'convertedTotalAmount', op: '>=' },
        { field: 'status', op: '=' },
    ];

    constructor() {
        super();
        this.init(InvoicePurchaseOrderGridViewDto);
    }

    protected getBadgeClass(status: InvoicePurchaseOrderStatus | undefined): string {
        return EnumUtils.getInvoicePurchaseOrderStatusBadgeClass(status);
    }

    addInvoicePurchaseOrder = async () => {
        await this.router.navigate(['/invoicing/purchase-orders/create']);
    };

    async onRowDblClick(e: DxDataGridTypes.RowDblClickEvent) {
        await this.router.navigate([
            `/invoicing/purchase-orders/details/${e.data.number}`,
        ]);
    }

    get canCreate(){
        return this.authService.checkPermission(PermissionType.InvoicePurchaseOrders, AccessType.Edit);
    }
}